// utils/currency.js

export function formatCurrencyIntl(amount = 0, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}

export function roundout(amount) {
    return Math.round((Number(amount) || 0) * 100) / 100;
}
